import { IPaginationResponse } from '../../../../core';
import { IUserResponse } from '../../../system-management';

const userResponse: IUserResponse = {
  id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
  autoIncrementalId: 0,
  firstName: 'string',
  lastName: 'string',
  email: 'string',
  account: {
    id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    autoIncrementalId: 0,
    englishName: 'string'
  },
  systemRoles: [
    {
      id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
      autoIncrementalId: 0,
      englishName: 'string'
    }
  ],
  specializedRoles: [
    {
      id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
      autoIncrementalId: 0,
      englishName: 'string'
    }
  ],
  specializedRoleIds: ['3fa85f64-5717-4562-b3fc-2c963f66afa6'],
  createdOnUtc: '2023-10-01T00:00:00Z',
  modifiedOnUtc: '2023-10-01T00:00:00Z',
};

const usersResponse: IPaginationResponse<IUserResponse> = {
  items: [userResponse, userResponse],
  paginationMetadata: {
    totalItemCount: 2,
    numberOfPages: 1,
    pageSize: 10,
    order: 'string',
    page: 1,
    hasNext: false,
    hasPrevious: false
  }
};

export const usersData = { userResponse, usersResponse };
